import { UserData, ClientInfo, Preference } from '../types'
import {
    ActionType,
    SIGNING,
    AUTHORIZED,
    UNAUTHORIZED,
    LOG_OUT,
    TUTORIAL_LINK_SET_ACTION,
    UPDATE_STRIPE_ACCOUNT
} from '../actions/signIn'

export interface SignInState {
    isSigned: boolean
    isSigningInProcess: boolean
    user?: ClientInfo
    tutorialLink?: Preference
    error?: string
}

const initialState: SignInState = {
    isSigningInProcess: false,
    isSigned: false,
    user: undefined,
    error: undefined,
}

export function signInReducer(state: SignInState = initialState, action: ActionType) {
    switch (action.type) {
        case SIGNING: {
            return {
                ...state,
                isSigningInProcess: true
            }
        }
        case AUTHORIZED: {
            return {
                ...state,
                isSigned: true,
                isSigningInProcess: false,
                user: action.payload.user
            }
        }
        case UNAUTHORIZED: {
            return {
                ...state,
                isSigningInProcess: false,
                isSigned: false,
                error: action.payload.error
            }
        }
        case TUTORIAL_LINK_SET_ACTION: {
            return {
                ...state,
                tutorialLink: action.payload.link
            }
        }
        case LOG_OUT: {
            return {
                ...state,
                isSigned: false
            }
        }
        case UPDATE_STRIPE_ACCOUNT: {

            const { stripeAccount, ...related } = state.user!

            return {
                ...state,
                user: {
                    stripeAccount: action.payload.stripeAccount,
                    ...related
                }
            }
        }
        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/signIn.ts